export const API_ENDPOINTS = {
  USERS: `/users`,
  RAUSERS: `/users/ra`,
  USER_BY_ID: (id) => `/users/${id}`,

  GENDERS: "/gender",
  GENDER_BY_ID: (id) => `/gender/${id}`,

  TRADERECOMMENDATIONS: "/traderecommendation",
  TRADERECOMMENDATIONS_BY_ID: (id) => `/traderecommendation/${id}`,

  PREF_STOCKS: "/prefstock",
  PREF_STOCK_BY_ID: (id) => `/prefstock/${id}`,

  PREFERENCES: "/preferenceonapp",
  PREFERENCE_BY_ID: (id) => `/preferenceonapp/${id}`,

  TIMELINE_CONTENT: "/timelinecontent",
  TIMELINE_CONTENT_BY_ID: (id) => `/timelinecontent/${id}`,

  getModules: "/module",
  getActions: "/action",

  TERMS_TYPES: "/termtype",

  FETCHINGCOUNTS: "/fetchingcount",

  NEWS: "/newsfeed",
  NEWS_BY_ID: (id) => `/newsfeed/${id}`,
  NEWS_CATEGORIES: "/newsfeed/categories",
  NEWS_IMAGES: "/newsfeed/images",
  PUBLISH: "/newsfeed/publish",
  NOTIFICATION_TYPES: "/notification-query",


  EDUCATION: "/educationfeed",
  EDUCATION_BY_ID: (id) => `/educationfeed/${id}`,
  EDUCATION_CATEGORIES: "/educationfeed/categories",
  EDUCATION_IMAGES: "/educationfeed/images",
  EDUCATION_PUBLISH: "/education/publish",
  EDUCATION_NOTIFICATION_TYPES: "/notification-query",



  GRIEVANCES: "/grievance",
  GRIEVANCES_BY_ID: (id) => `/grievance/${id}`,
  TRADE_TYPE: "/tradetype",
  SCRIPT: "/script",
  SCRIPT_TYPE: "/scripttype",
  TARGET_STATUS: "/target-status",
  TAG_SECTOR: "/tagsector",
  TAG_INDUSTRY: "/tagindustry"
};

export const HTTP_METHODS = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE",
};

export const USER_FORM_FIELDS = {
  NAME: "name",
  EMAIL: "email",
  PHONE: "phone",
  SIGNUP_ID: "signupid",
  SIGNUP_DEVICE_ID: "signupdeviceid",
  IS_RESEARCH_ANALYST: "isresearchanalyst",
};

export const VALIDATION_MESSAGES = {
  REQUIRED: "This field is required",
  INVALID_EMAIL: "Please enter a valid email address",
  INVALID_PHONE: "Please enter a valid phone number",
  MIN_LENGTH: (min) => `Minimum ${min} characters required`,
  MAX_LENGTH: (max) => `Maximum ${max} characters allowed`,
};


